import { render } from "./Information.vue?vue&type=template&id=06cf0676&scoped=true"
import script from "./Information.vue?vue&type=script&lang=ts"
export * from "./Information.vue?vue&type=script&lang=ts"

import "./Information.vue?vue&type=style&index=0&id=06cf0676&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-06cf0676"

export default script